import { NgModule, Injectable } from '@angular/core';
import { RouterModule, Routes, CanActivate, Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { RoleGuard } from './core/guards/role.guard';
import { UserRole } from './core/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    let isLoggedIn = false;
    this.authService.isLoggedIn$.subscribe(v => isLoggedIn = v).unsubscribe();
    if (!isLoggedIn) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { 
    path: 'login', 
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) 
  },
  { 
    path: 'dashboard', 
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard]
  },
  { 
    path: 'donors', 
    loadChildren: () => import('./features/donors/donors.module').then(m => m.DonorsModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard]
  },
  { 
    path: 'reports', 
    loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard]
  },
  { 
    path: 'pledges', 
    loadChildren: () => import('./features/pledges/pledges.module').then(m => m.PledgesModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard]
  },
  { 
    path: 'financial', 
    loadChildren: () => import('./features/financial/financial.module').then(m => m.FinancialModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard]
  },
  { 
    path: 'operations', 
    loadChildren: () => import('./features/operations/operations.module').then(m => m.OperationsModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard]
  },
  { 
    path: 'campaigns', 
    loadChildren: () => import('./features/campaigns/campaigns.module').then(m => m.CampaignsModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule).catch(() => import('./features/auth/auth.module').then(m => m.AuthModule)),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.SUPER_ADMIN] }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
